import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var query_pagination_previous_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M16 10.5v3h3v-3h-3zm-5 3h3v-3h-3v3zM7 9l-3 3 3 3 1-1-2-2 2-2-1-1z" }) });
export {
  query_pagination_previous_default as default
};
//# sourceMappingURL=query-pagination-previous.js.map
